import { Filter } from "./Filter";

/**
 * PromptTemplate Organism 모듈
 *
 * @description Prompt Template 관련 오가니즘들을 모아놓은 모듈
 * @author Max <sud665@ymjlab.com>
 * @version 1.0.0
 * @since 2025-01-29
 */
export default {
  Filter,
};

